import {Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {HighlightedText} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';

import {TelemedicineCardProps} from './types';
import {StyledCard} from '../../styles';

const {telemedicineAppointment} = translations['pt-br'].commons;

export function TelemedicineCard({onClick, query}: TelemedicineCardProps) {
	const theme = useTheme();

	return (
		<StyledCard
			onClick={onClick}
			$isCursorPointer
			data-tag-id={AppointmentBookingEnum.SELECIONOU_TELECONSULTA}
			elevation={0}
			sx={{
				backgroundColor: theme.palette.primary.main,
				height: '100%',
			}}>
			<Stack direction="row" gap={1} alignItems={'center'} p={2}>
				<Stack minWidth={20}>
					<Icon
						name={'remember-me-filled'}
						size={24}
						color={theme.palette.common.white}
					/>
				</Stack>
				<Typography variant="subtitle1" fontWeight={600} lineHeight={1} color={'white'}>
					<HighlightedText text={telemedicineAppointment} highlight={query} />
				</Typography>
				<Stack ml="auto">
					<Icon name="arrow-right" size={24} color={'white'} />
				</Stack>
			</Stack>
		</StyledCard>
	);
}
